// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Result = require("@rescript/core/src/Core__Result.res.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_wrk_pattern_search_v1 = require("./MM_wrk_pattern_search_v1.res.js");
var MM_wrk_pattern_search_v2 = require("./MM_wrk_pattern_search_v2.res.js");

function frameMatchesPattern(frame, pattern) {
  if (pattern.TAG === "V1") {
    if (MM_wrk_pattern_search_v1.frameMatchesPattern(frame, pattern.pattern, pattern.mapping)) {
      return {
              TAG: "Matched",
              _0: undefined
            };
    } else {
      return "NotMatched";
    }
  }
  var matchedIndices = MM_wrk_pattern_search_v2.frameMatchesPatterns(frame, pattern._0);
  if (typeof matchedIndices !== "object") {
    return "NotMatched";
  } else {
    return {
            TAG: "Matched",
            _0: matchedIndices._0
          };
  }
}

function parsePattern(patternStr, patternVersion, ctx) {
  if (patternVersion === 1) {
    return Core__Result.map(MM_wrk_pattern_search_v1.makeSearchPattern(patternStr, ctx), (function (pat) {
                  return {
                          TAG: "V1",
                          pattern: pat,
                          mapping: Belt_HashMapInt.make(10)
                        };
                }));
  } else if (patternVersion === 2) {
    return Core__Result.map(MM_wrk_pattern_search_v2.parsePattern(patternStr, undefined, Caml_option.some(ctx)), (function (pat) {
                  return {
                          TAG: "V2",
                          _0: pat
                        };
                }));
  } else {
    return {
            TAG: "Error",
            _0: "Unexpected pattern version " + patternVersion.toString()
          };
  }
}

function patternIsEmpty(pattern) {
  if (pattern.TAG === "V1") {
    return pattern.pattern.length === 0;
  } else {
    return pattern._0.length === 0;
  }
}

exports.parsePattern = parsePattern;
exports.frameMatchesPattern = frameMatchesPattern;
exports.patternIsEmpty = patternIsEmpty;
/* MM_wrk_pattern_search_v1 Not a pure module */
